// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"172": "common-async","846": "Approval-vue",}[chunkId] + "." + {"172": "607e3446c46ea4f2","846": "b17ec04ed1027b2e",}[chunkId] + ".css"
}